export * from './bar/bar.component';
export * from './pie/pie.component';
export * from './chart.component';
